export const SUBSIDY_CATEGORY_MAP = {
  직불금: [
    { id: '00581ec6-e12c-46e9-a0bf-92de6c47830a', name: '직불금' },
    { id: '333a6dee-2055-45ce-8468-bf7b43eb82a2', name: '농민수당' },
  ],
  '농기계·자재': [
    { id: 'f0126d27-bf62-4930-b53b-8818c739414f', name: '농기계' },
    { id: '3ad8746d-d4a8-4c2e-af46-7e0ad02bcd5e', name: '드론' },
    { id: '5f8c0b47-06c8-4310-b53b-4c42e6845e29', name: '비료' },
    { id: 'f03acf28-bea0-40a2-b2c8-c050c83cca82', name: '상토' },
    { id: 'aee4510a-9ca4-48b5-9f1c-0b7d5295050d', name: '농약' },
    { id: 'ff478d2a-a68f-4704-a2d0-5deda4edd2ea', name: '종자' },
    { id: 'd98407e0-d11d-4bbe-a91b-6dbec10edece', name: '멀칭필름' },
  ],
  시설: [
    { id: 'e38050b4-12a4-48bc-9aa0-727ede618955', name: '시설' },
    { id: 'bd02900e-553a-4e33-9f16-7817ff6f989f', name: '스마트팜' },
    { id: '94518ffe-03d1-466d-b2c4-6f692482b2f2', name: '비닐하우스' },
    { id: '9278a77f-07a7-439c-bebf-79c8442a5970', name: '저온저장고' },
    { id: 'e7e2e5e0-1c25-4117-b0ce-7f377d9041c1', name: '관정' },
    { id: 'ff47d281-255c-45a4-b86a-3d926586451f', name: '축사' },
  ],
  맞춤지원: [
    { id: '0abd3724-12d6-4eaa-b5df-6d00d498d1b0', name: '청년농' },
    { id: '632dbe88-59b0-45d3-89fc-724aadffd6cc', name: '여성농' },
    { id: '02b044a5-350d-4830-8ad5-acfc039cde7b', name: '귀농인' },
    { id: '7946b617-03cd-40a7-8f25-2b0bbea2e66a', name: '고령농' },
  ],
  식량작물: [
    { id: '296a56e5-fac1-41bb-8e83-11b569b3cccc', name: '쌀' },
    { id: 'fe1866b9-63cd-4372-a31c-e646ba385438', name: '벼' },
    { id: '813f0674-f770-42e2-88aa-584683d1e17a', name: '콩' },
    { id: '536ee75b-46fb-40b6-9de5-d277ed153568', name: '잡곡' },
  ],
  '과수·원예': [
    { id: 'dfe8d070-5151-4c91-8944-b705b2fbcf64', name: '과수' },
    { id: '74294390-b70c-414c-bb2d-5c80b4ad6e28', name: '채소' },
    { id: '2a1bc5e4-6c35-42d7-88c7-2e6e18f041db', name: '특화작물' },
  ],
  축산: [
    { id: 'c331d127-1e8b-449e-be69-ed55d60c7716', name: '한우' },
    { id: '66de3638-c0cd-4fcb-ae9d-b8c7f871b91f', name: '축산' },
    { id: 'f385ca97-c208-490b-8fad-1bc15e726d1a', name: '방역' },
  ],
  '유통·판매': [
    { id: '79f88c6f-c4a7-432d-b230-4c765f800724', name: '택배비' },
    { id: '02e59a66-1d75-430a-b52c-c8411ff4b787', name: '포장재' },
    { id: 'e96ca1c2-24b2-4c5b-8acf-a53a39077ce8', name: '로컬푸드' },
    { id: '3213c000-f3fc-42ad-8919-56c97d6c6a63', name: '직거래' },
  ],
} as const;

export type SubsidyCategoryType = keyof typeof SUBSIDY_CATEGORY_MAP | '전체';

export const SUBSIDY_CATEGORIES: SubsidyCategoryType[] = [
  '전체',
  '농기계·자재',
  '시설',
  '식량작물',
  '과수·원예',
  '축산',
  '유통·판매',
  '맞춤지원',
];
